import { createGlobalState } from "react-use";

const useENV = createGlobalState({
  "API_ROUTER": null,
  "CHAIN_ID": null,
  "RPC_URL": null,
  "VERSION_REPO_ADDRESS": null
});

export default useENV;